import { render, staticRenderFns } from "./wrapper-click-ignored.vue?vue&type=template&id=0fefd645&"
import script from "./wrapper-click-ignored.vue?vue&type=script&lang=js&"
export * from "./wrapper-click-ignored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports